// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__UPwUc","img":"Contacts_img__brr4z","details":"Contacts_details__WQrZ2","address":"Contacts_address__fr3KF","link":"Contacts_link__6iw-C"};